import React from 'react';
import { FormControl, InputLabel, Select, MenuItem, Box } from '@mui/material';

export const AI_PROVIDERS = [
    {
        value: 'OLLAMA',
        label: 'Ollama / Local Server',
        models: [
            { id: 'gemma3:270m', name: 'Gemma 3 270m (Local)' },
            { id: 'qwen2.5-coder:latest', name: 'Qwen 2.5 Coder (Local)' },
            { id: 'llama3.2:latest', name: 'Llama 3.2 (Local)' }
            
        ]
    },
    {
        value: 'OPENROUTER',
        label: 'OpenRouter',
        models: [
            { id: 'google/gemma-4-26b-a4b-it:free', name: 'Gemma 4 26B A4B IT' },
            { id: 'google/gemma-4-31b-it:free', name: 'Gemma 4 31B IT' }
        ]
    },
    {
        value: 'GEMINI',
        label: 'Google AI Studio',
        models: [
            { id: 'gemma-4-26b-a4b-it', name: 'Gemma 4 26B A4B IT' },
            { id: 'gemini-3.5-flash-lite', name: 'Gemini 3.5 Flash Lite' },
            { id: 'gemini-3.6-flash', name: 'Gemini 3.6 Flash' },
            { id: 'gemma-4-31b-it', name: 'Gemma 4 31B IT' }
        ]
    },
    {
        value: 'OPENAI',
        label: 'OPEN AI',
        models: [
            { id: 'gpt-4o-mini', name: 'GPT-4o Mini' }
        ]
    }
];

export default function ModelSelector({ selectedModel, onModelChange, selectAIProvider, onAiProviderChange }) {
    
    const handleProviderChange = (event) => {
        const newProviderValue = event.target.value;
        onAiProviderChange(newProviderValue);

        const matchedProvider = AI_PROVIDERS.find(p => p.value === newProviderValue);
        if (matchedProvider && matchedProvider.models.length > 0) {
            onModelChange(matchedProvider.models[0].id);
        }
    };

    return (
        <Box 
            sx={{
                display: 'flex',
                flexDirection: { xs: 'column', md: 'row' },
                gap: 2,
                alignItems: 'center'
            }}
        >
            {/* Provider Selector */}
            <FormControl size="small" fullWidth>
                <InputLabel id="provider-select-label">AI Provider</InputLabel>
                <Select
                    labelId="provider-select-label"
                    id="providerSelect"
                    value={selectAIProvider}
                    label="AI Provider"
                    onChange={handleProviderChange}
                >
                    {AI_PROVIDERS.map((provider) => (
                        <MenuItem key={provider.value} value={provider.value}>
                            {provider.label}
                        </MenuItem>
                    ))}
                </Select>
            </FormControl>

            {/* Model Selector */}
            <FormControl size="small" fullWidth>
                <InputLabel id="model-select-label">Model Version</InputLabel>
                <Select
                    labelId="model-select-label"
                    id="modelSelect"
                    value={selectedModel}
                    label="Model Version"
                    onChange={(e) => onModelChange(e.target.value)}
                >
                    {AI_PROVIDERS.find(p => p.value === selectAIProvider)?.models.map((mod) => (
                        <MenuItem key={mod.id} value={mod.id}>
                            {mod.name} ({mod.id})
                        </MenuItem>
                    ))}
                </Select>
            </FormControl>
        </Box>
    );
}